/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import { TableCell, TableRow, Checkbox, Typography, TextField, FormControlLabel } from "@mui/material";
import clsx from "clsx";
import { Link, NavLink } from "react-router-dom";
import ElipsisIcon from "../../../../../assets/images/icon_actions/Elipsis.svg";
import { Image, Space, Dropdown, Menu, Modal } from "antd";
import { InvoiceHistory } from "../../../../../config/constant";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import moment from 'moment';
import { currencyFormat, checkCRUDPermission, checkComponentPermission, getColumnWidth, downloadTitle, idNamingConversion } from "../../../../../helpers/utilities";
import crudActions from "../../../../CRUD/redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import usePrevious from "../../../../Shared/components/Previous";
import InvoiceModal from "../../../../Shared/components/InvoiceModal";
import SalesModal from "../../../../Shared/components/SalesModal";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { AESEncrypt } from "../../../../../helpers/Crypto";
import SearchText from '../../../../Shared/components/SearchText';


export const ListTable = (props) => {
    const { onSelected, onRequestSort, sortOrder, sortBy, details,
        loadTasks, businessDetails, loadMore, loadMoreContent, loadMoreTask, roleManagement, search, dateValue, dataSettle, overDue, customerId } = props;
    const [open, setOpen] = useState(false);
    const { rejectDetails } = useSelector(state => state.younoteAdminSetupReducer);
    const [selected, setSelected] = useState([]);
    const { readDetails, readError, editDetails, createDetails, createError, createLoader, editLoader } = useSelector(state => state.crudReducer);
    const dispatch = useDispatch();
    const prevReadDetails = usePrevious(readDetails);
    const prevEditDetails = usePrevious(editDetails);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevReadError = usePrevious(readError);
    const [deleteModal, setDeleteModal] = useState(false);
    const [invoiceId, setInvoiceId] = useState('');
    //const [number, setNumber] = useState('');
    const [comments, setComments] = useState('');
    const [datas, setDatas] = useState({});
    const [source, setSource] = useState({});
    const [visible, setVisible] = useState(false);
    const [reasonId, setReasonId] = useState('');
    const [copyBill, setCopyBill] = useState(false);
    const [copy, setCopy] = useState(false);
    const [originalDetails, setOrigialDetails] = useState('');
    const [billId, setBillId] = useState('');

    useEffect(() => {
        onSelected(selected);
    }, [selected]);

    const handleClick = (e, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };

    const isSelected = (name) => selected.indexOf(name) !== -1;

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
        setReasonId('');
        setCopyBill(false);
        setInvoiceId('');
        setBillId('');
    }

    const handleShareDocument = (data, copy) => {
        setCopy(copy);
        setSource(data?.source);
        if (data?.source !== 'SALES ORDER') {
            dispatch({
                type: crudActions.READ_DETAILS_START,
                id: (data?.source === 'STORE SALES INVOICE' || data?.source === 'STORE SALES RETURN') ? data.storeSalesId : data.selfBillId,
                url: (data?.source === 'STORE SALES INVOICE' || data?.source === 'STORE SALES RETURN') ? 'store-sales' : "selfBill"
            });
        } else {
            data.selfBillItems = data?.salesInvoiceItems || [];
            data.includeGst = data?.salesOrder?.includeGst || false;
            setOrigialDetails(data);
            setOpen(true);
        }
    }


    const handleOk = () => {
        setVisible(false);
        setDatas({});
        setComments('');
    };


    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            setOpen(true);
            setOrigialDetails(readDetails);
        } else if (prevReadError !== undefined && readError && prevReadError !== readError) {

        }
    }, [readDetails]);

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            toast(editDetails);
            loadTasks();
            handleOk();
        }
    }, [editDetails]);


    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            toast.dismiss();
            toast(createDetails);
            if (copyBill) {
                dispatch({
                    type: crudActions.CREATE_DETAILS_START,
                    url: `selfBill/${billId}/clone/`,
                    typeTitle: "Invoice has been Cancelled Successfully"
                });
            }
            loadTasks();
            handleDeleteModal();
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let message = createError.error.message;
            handleDeleteModal();
            toast.dismiss();
            toast.error(message);
        }
    }, [createDetails, createError]);

    const handleClose = (o) => {
        setOpen(o);
        setSource('');
    };

    const onDelete = (data) => {
        setDeleteModal(true);
        setInvoiceId(data.id);
        setBillId(data.selfBillId);
    }

    const onHold = (data) => {
        setDatas(data);
        setVisible(true);
    }

    const handleHoldSubmit = () => {
        dispatch({
            type: crudActions.EDIT_DETAILS_START,
            url: "salesInvoice",
            title: `Sales Invoice ${datas.onHold ? 'Un Hold' : 'Hold'}`,
            id: datas.id,
            details: { 'onHold': !datas.onHold, comment: comments }
        })
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const onDeleteOk = () => {
        dispatch({
            type: crudActions.CREATE_DETAILS_START,
            url: `salesInvoice/${invoiceId}/cancel/${reasonId}`,
            typeTitle: "Invoice has been Cancelled Successfully",
            id: datas.id,
        });
    }

    const classes = customStyles();
    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={InvoiceHistory}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                width={true}
                sortBy={sortBy}
                loadMoreTask={() => loadMoreTask()}
                details={details}
                className={classes.margin15t}
                selected={selected}
                onSelected={(value) => setSelected(value)}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={InvoiceHistory.length}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i}  >
                                                <TableCell className={clsx('checkbox', classes.tablealign)} onClick={(e) => handleClick(e, data.id)} padding="checkbox">
                                                    <Checkbox
                                                        color="primary"
                                                        checked={isSelected(data.id)}
                                                    />
                                                </TableCell>
                                                <TableCell className={classes.positionRelative} style={{ width: getColumnWidth(InvoiceHistory, 0) }}>
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Customer Invoice History', 'view', 'Sales') ?
                                                            <><Link id={idNamingConversion('View_' + data.id, 'customerInvoiceHistory', 'Link')} style={{ width: getColumnWidth(InvoiceHistory, 0) }} to={`/sales/transactions/invoice-history/${AESEncrypt(data.id)}/view`} className={clsx(classes.color, classes.positionRelative, classes.disBlock, classes.bold)}>
                                                                {`${data.serialNo}`}
                                                            </Link>{data.onHold && <b className={clsx(classes.new, classes.openButton, classes.statusButton)}>Hold</b>}</> : <><span style={{ width: getColumnWidth(InvoiceHistory, 0) }}>{data?.serialNo}</span>{data.onHold && <b className={clsx(classes.new, classes.openButton, classes.statusButton)}>Hold</b>}</>
                                                    }
                                                </TableCell>
                                                <TableCell style={{ width: getColumnWidth(InvoiceHistory, 1) }}><span style={{ width: getColumnWidth(InvoiceHistory, 1) }}>{moment(data.invoiceDate).format('DD MMM YYYY')}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(InvoiceHistory, 2) }}><span style={{ width: getColumnWidth(InvoiceHistory, 2) }}>{moment(data.dueDate).format('DD MMM YYYY')}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(InvoiceHistory, 3) }}><span style={{ width: getColumnWidth(InvoiceHistory, 3) }}>{moment(data.createTs).format('DD MMM YYYY hh:mm A')}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(InvoiceHistory, 4) }}><span style={{ width: getColumnWidth(InvoiceHistory, 4) }}>{data?.customer?.name || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(InvoiceHistory, 5) }}><span style={{ width: getColumnWidth(InvoiceHistory, 5) }}>{data?.customer?.serialNo || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(InvoiceHistory, 6) }} className={classes.rightAlignAmount}><span style={{ width: getColumnWidth(InvoiceHistory, 6) }}>{`₹ ${currencyFormat(data.invoiceAmount)}`}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(InvoiceHistory, 7) }} className={classes.rightAlignAmount}><span style={{ width: getColumnWidth(InvoiceHistory, 7) }}>{`₹ ${currencyFormat(data.balanceAmount)}`}</span></TableCell>
                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Customer Invoice History', 'view', 'Sales') &&
                                                            <Link id={idNamingConversion('View_' + data.id, 'customerInvoiceHistory', 'Icon')} to={`/sales/transactions/invoice-history/${AESEncrypt(data.id)}/view`}>
                                                                <Image
                                                                    src={ViewIcon}
                                                                    preview={false}
                                                                />
                                                            </Link>
                                                        }
                                                        <Dropdown
                                                            trigger={['click']}
                                                            placement={'bottomRight'}
                                                            overlay={
                                                                <Menu className={clsx(classes.groupMenu)}>
                                                                    <Menu.Item key={"arrow"} className={clsx(classes.accordionSubmenuArrow)}></Menu.Item>
                                                                    {
                                                                        !data?.onHold ?
                                                                            <>
                                                                                {
                                                                                    roleManagement !== '' && checkComponentPermission('Customer Invoice History', 'Ellipsis Action', 'Make Payment') &&
                                                                                    (data.source === 'SALES SELF BILL' || data.source === 'SALES ORDER') &&
                                                                                    <Menu.Item key={"settle"}>
                                                                                        <NavLink className={clsx({ [classes.disabled]: data.isSettled })}
                                                                                            to={`/sales/sales-management/customer-payment/${AESEncrypt(data.customerId)}/${data.id}/create`} id={idNamingConversion('Collect Payment_' + data.id, 'customerInvoiceHistory', 'Icon')}>Collect Payment</NavLink>
                                                                                    </Menu.Item>
                                                                                }
                                                                                {
                                                                                    data.billStatus === 'CREATED' && (
                                                                                        <Menu.Item key={"cancel"} title={data.source === 'SALES CREDIT NOTE' ? 'Credit Note cant be Cancelled' : ''}>
                                                                                            {
                                                                                                roleManagement !== '' &&
                                                                                                checkComponentPermission('Customer Invoice History', 'Ellipsis Action', 'Cancel Invoice') &&
                                                                                                (data.source === 'SALES SELF BILL' || data.source === 'SALES ORDER') &&
                                                                                                <NavLink to={'#'} className={clsx({ [classes.disabled]: data.settledAmount > 0 })} onClick={() => onDelete(data)} id={idNamingConversion('Cancel Invoice_' + data.id, 'customerInvoiceHistory', 'Icon')}>Cancel Invoice</NavLink>
                                                                                            }
                                                                                        </Menu.Item>
                                                                                    )
                                                                                }
                                                                                {
                                                                                    roleManagement !== '' && checkComponentPermission('Customer Invoice History', 'Ellipsis Action', 'Hold') &&
                                                                                    <Menu.Item key={"hold"}><NavLink className={clsx({ [classes.disabled]: data.isSettled })} to={'#'} onClick={() => onHold(data)} id={idNamingConversion('Hold_' + data.id, 'customerInvoiceHistory', 'Icon')}>Hold</NavLink></Menu.Item>
                                                                                }
                                                                            </> : <>
                                                                                {
                                                                                    roleManagement !== '' && checkComponentPermission('Customer Invoice History', 'Ellipsis Action', 'Hold') &&
                                                                                    <Menu.Item key={"hold"}><NavLink to={'#'} onClick={() => onHold(data)}>Un Hold</NavLink></Menu.Item>
                                                                                }
                                                                            </>
                                                                    }
                                                                    {
                                                                        data?.source === 'STORE SALES INVOICE' ? <Menu.Item key={"View Document"}><NavLink to={'#'} onClick={() => handleShareDocument(data, false)} id={idNamingConversion('View Document_' + data.id, 'customerInvoiceHistory', 'Icon')}>View Document</NavLink></Menu.Item>
                                                                            : <>
                                                                                {
                                                                                    roleManagement !== '' && checkComponentPermission('Customer Invoice History', 'Ellipsis Action', 'Share Document') &&
                                                                                    <Menu.Item key={"View Document"}><NavLink to={'#'} onClick={() => handleShareDocument(data, false)} id={idNamingConversion('View Original_' + data.id, 'customerInvoiceHistory', 'Icon')}>View Original</NavLink></Menu.Item>
                                                                                }
                                                                                {console.log(checkComponentPermission('Customer Invoice History', 'Ellipsis Action', 'View Copy'), 'Customer Invoice History')}
                                                                                {
                                                                                    roleManagement !== '' && checkComponentPermission('Customer Invoice History', 'Ellipsis Action', 'View Copy') &&
                                                                                    <Menu.Item key={"View Copy"}><NavLink to={'#'} onClick={() => handleShareDocument(data, 'Duplicate Copy')} id={idNamingConversion('View Duplicate_' + data.id, 'customerInvoiceHistory', 'Icon')}>View Duplicate</NavLink></Menu.Item>
                                                                                }
                                                                                {
                                                                                    roleManagement !== '' && checkComponentPermission('Customer Invoice History', 'Ellipsis Action', 'View Triplicate') &&
                                                                                    <Menu.Item key={"View Triplicate"}><NavLink to={'#'} onClick={() => handleShareDocument(data, 'Triplicate Copy')} id={idNamingConversion('View Triplicate_' + data.id, 'customerInvoiceHistory', 'Icon')}>View Triplicate</NavLink></Menu.Item>
                                                                                }
                                                                            </>
                                                                    }
                                                                </Menu>
                                                            }>
                                                            <Image id={idNamingConversion('Elipsis_' + data.id, 'customerInvoiceHistory', 'Icon')} src={ElipsisIcon} preview={false} />
                                                        </Dropdown>
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={InvoiceHistory.length}>
                                                    {
                                                        search !== '' ? <SearchText /> :
                                                            <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>
                                                                {
                                                                    (customerId || (dateValue[0] !== null && dateValue[1] !== null) || overDue || dataSettle) ? <>
                                                                        {
                                                                            dataSettle === 'un-paid' ? <><p>All Invoices will be listed here when transactions are recorded by the system</p></> :
                                                                                'Sorry, we couldn’t find any match for the filtered criteria. Please refine your filter.'
                                                                        }
                                                                    </> : <>
                                                                        {
                                                                            dataSettle === '' ? 'Sorry, we couldn’t find any match for the filtered criteria. Please refine your filter.' : 'All Invoices will be listed here when transactions are recorded by the system'
                                                                        }
                                                                    </>
                                                                }
                                                            </p>
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </>
                }
            />
            {
                open && (
                    <>
                        {
                            (source === 'STORE SALES INVOICE' || source === 'STORE SALES RETURN') ? <SalesModal
                                visible={open}
                                classes={classes}
                                handleClose={() => handleClose(false)}
                                details={originalDetails}
                            /> : <InvoiceModal link={""}
                                copy={copy}
                                title={downloadTitle(originalDetails, 'sales-bill')}
                                //title={`Sales-Bill-${readDetails?.id}`}
                                open={open} handleClose={(o) => handleClose(o)}
                                {...props} businessDetails={businessDetails}
                                format={originalDetails?.billFormat} details={originalDetails} />
                        }
                    </>
                )
            }
            <Modal
                title={'Info Log Message'}
                width={460}
                open={visible}
                onOk={() => handleOk()}
                onCancel={() => handleOk()}
                // closeIcon={<CloseIcon />}
                footer={[
                    <NavLink to={"#"}
                        className={clsx(classes.modalBtn, { [classes.loadingA]: editLoader }, { [classes.disabled]: comments === '' })}
                        onClick={() => handleHoldSubmit()}
                    >OK</NavLink>
                ]}
                className={clsx(classes.commonPopup, classes.commonPopupText, classes.removeUnderline, classes.deletePopup)}>
                <Typography variant={'subtitle1'} className={clsx(classes.fonSize14, classes.textAlignLeft)} style={{ color: "#1c314c" }}>
                    Please mention your reason for hold / unhold comments below</Typography>
                <Space direction={'vertical'} className={classes.modalPaper} style={{ width: "100%", margin: "0" }}>
                    <TextField autoComplete='one-time-code'
                        label={["Comments ", <span key={"Comments"} className={classes.colorRedRequired}> *</span>]}
                        variant={'standard'}
                        fullWidth
                        value={comments}
                        InputProps={{
                            classes: {
                                input: classes.textFieldColor,
                            }
                        }}
                        InputLabelProps={{
                            className: classes.textFieldLableColorCustom,
                        }}
                        onChange={(e) => setComments(e.target.value)}
                    />
                </Space>
            </Modal>
            <Modal
                title={'Info Log Message'}
                width={460}
                open={deleteModal}
                onOk={() => handleDeleteModal(!deleteModal)}
                onCancel={() => handleDeleteModal(!deleteModal)}
                // closeIcon={<CloseIcon />}
                footer={[
                    <NavLink to={"#"}
                        className={clsx(classes.modalBtn, { [classes.loadingA]: createLoader }, { [classes.disabled]: reasonId === '' })}
                        onClick={() => onDeleteOk()}
                    >OK</NavLink>
                ]}
                className={clsx(classes.commonPopup, classes.commonPopupText, classes.removeUnderline, classes.deletePopup)}>
                <Typography variant={'subtitle1'} className={clsx(classes.fonSize14, classes.textAlignLeft)} style={{ color: "#1c314c" }}>
                    Are You Sure you want to Cancel the Selected Invoice? If Yes Mention the Reason for Cancellation below</Typography>
                <AutoCompleteComponent
                    name={["Reason Codes ", <span key={'Catalogue Name'} className={classes.colorRedRequired}> *</span>]}
                    heads={[{ 'key': 'rejectReasonDesc', 'name': 'Description' }, { 'key': 'rejectReasonCode', 'name': 'Codes' }]}
                    details={rejectDetails}
                    parentValue={customObject(rejectDetails, reasonId)}
                    position={"bottom"}
                    customClasses={classes.margin20t}
                    onChange={(data) => setReasonId(data.id)}
                />
                <FormControlLabel
                    style={{ marginTop: '10px', fontSize: '14px !important' }}
                    control={<Checkbox color="primary" style={{ fontSize: '14px !important' }} checked={copyBill} onChange={(e) => setCopyBill(e.target.checked)} />}
                    label="Copy New Bill"
                />
            </Modal>
        </>
    )
}